// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"projects_signup_src_app_public_public_module_ts":"b053151221108c24","projects_signup_src_app_public_signup_signup_module_ts":"e12d0da191d54392","node_modules_ngx-quill_fesm2022_ngx-quill-quill-CUw8Q_m0_mjs":"7b418557564a93ee"}[chunkId] + ".js";
};